// src/components/PDFMetadataViewer.jsx
import React, { useEffect, useState } from 'react';
import { getPDFMetadata } from '../utils/pdfUtils';

const PDFMetadataViewer = ({ pdfUrl }) => {
  const [metadata, setMetadata] = useState(null);

  useEffect(() => {
    const fetchMetadata = async () => {
      const data = await getPDFMetadata(pdfUrl);
      setMetadata(data);
    };

    if (pdfUrl) {
      fetchMetadata();
    }
  }, [pdfUrl]);

  return (
    <div style={{ width: "320px" }}>
      {metadata ? (
        <div className='custom-toolbar_props_data_container'>
          <h3>PDF Metadata</h3>
          <p>Title: {metadata.info.Title || 'N/A'}</p>
          <p>Author: {metadata.info.Author || 'N/A'}</p>
          <p>Creation Date: {metadata.info.CreationDate || 'N/A'}</p>
          <p>Subject: {metadata.info.Subject}</p>
          <p>Keywords: {metadata.info.Keywords}</p>
          <p>Creator: {metadata.info.Creator}</p>
          <p>Producer: {metadata.info.Producer}</p>
          <p>Modification Date: {metadata.info.ModDate}</p>
          {/* Add more metadata fields as needed */}
        </div>
      ) : (
        <p>Loading metadata...</p>
      )}
    </div>
  );
};

export default PDFMetadataViewer;
